import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SupplierPaymentOrderItem } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';



interface Props {
    SupplierPaymentOrder: any;
    ItemJsconCode: string;
    onChange: Function;
    label?: string;
}

export const EditorBudgetItemArticles = ({ SupplierPaymentOrder, ItemJsconCode, onChange, label }: Props) => {

    const { instance, setLista, lista, setBean, bean } = useDataBean(_SupplierPaymentOrderItem)

    const [valor, setValor] = useState<string>();
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (SupplierPaymentOrder.IDSupplierPaymentOrder) {
            getLista();
        }
    }, [SupplierPaymentOrder, ItemJsconCode])

    const getLista = () => {
        instance.getRecordBudgetBySupplierPaymentOrder(SupplierPaymentOrder.IDSupplierPaymentOrder, SupplierPaymentOrder.SupplierPaymentOrderDate, ItemJsconCode).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const head = [
        { title: 'ID Artículo', property: 'IDDocument', visible: false },
        { title: 'Mnemonico', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Valor Registro Presupuestal', property: 'Value', visible: true },
        { title: 'Valor Obligado', property: 'OBValue', visible: true },
        { title: 'Valor Disponible para Orden de Pago', property: 'LeftValue', visible: true },
    ]

    const getItem = () => {
        if (bean.IDDocument) {
            setModal({ ...modal, "view": false })
            setValor(`${bean.Mnemonic} - ${bean.Consecutive}`);
            onChange(bean)
        } else {
            toast.error("Documento no valido")
        }
    }

    return (
        <>
            <label>{label ?? "Documento Seleccionado"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Busqueda de Documento" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                </div>
            </Modal>
        </>
    )
}